/**
 * Die gemeinsame Fehlergrenze der nachgeladenen Dialoge: `MassenuploadDialogLazy.tsx`, `ArtworkPruefungEinzelheitenLazy.tsx` und
 * `ZollKnopfLazy.tsx` (dazu die innere Grenze um den Zolldialog in `ZollKnopf.tsx`). Ein alter Tab nach einem Deployment kennt den
 * Chunk nicht mehr, `import()` scheitert, `React.lazy` wirft beim Rendern; ohne Grenze dazwischen ersetzte die Wurzelgrenze
 * (`FehlerGrenze` in `src/App.tsx`) die GANZE Anwendung. Die Grenze meldet, ruft `onSchliessen` (falls es eines gibt) und zeichnet
 * nichts. Eine Klasse statt dreier Kopien, weil sie im Eintrittsbuendel liegt (Grenze in `test/reference/bundle.test.ts`).
 *
 * Importiert `state/fehlerStapel.ts` NICHT (Rolldown-Falle, AGENTS.md „Rolldown zerlegt das Eintrittsbuendel“): das Modul liegt im
 * Eintritt und im Chunk `ZollKnopf`, ein Import des Fehlerstapels liesse Rolldown das Eintrittsbuendel zerlegen. `melde` kommt
 * deshalb als Prop; `nachladeGrenze.test.tsx` bewacht das. Nur `react` darf hier hereinkommen.
 */
import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

export interface NachladeGrenzeEigenschaften {
  /**
   * Meldet in den Fehlerstapel. Hereingereicht, weil dieses Modul fehlerStapel.ts nicht importieren darf. Wird ohne `this` aufgerufen:
   * eine freie Funktion oder die Funktion eines Objektliterals (`ZOLL_MELDER`, `PRUEF_MELDER`) genuegt, keine Pfeilfunktion noetig.
   */
  melde: (fehler: unknown, kontext: string) => void;
  /** Der Satz fuer den Fehlerstapel, z. B. „Der Massenupload wurde abgebrochen.“ */
  kontext: string;
  /** Beim Einsatz um einen Dialog: schliesst ihn. Die aeussere Grenze um einen ganzen Chunk hat nichts zu schliessen. */
  onSchliessen?: () => void;
  children: ReactNode;
}

export class NachladeGrenze extends Component<NachladeGrenzeEigenschaften, { abgestuerzt: boolean }> {
  state = { abgestuerzt: false };

  static getDerivedStateFromError(): { abgestuerzt: boolean } {
    return { abgestuerzt: true };
  }

  componentDidCatch(fehler: unknown, info: ErrorInfo): void {
    const { melde, kontext, onSchliessen } = this.props;
    console.error(kontext, fehler, info.componentStack);
    melde(fehler, kontext);
    onSchliessen?.();
  }

  render(): ReactNode {
    return this.state.abgestuerzt ? null : this.props.children;
  }
}
